export function registerOfflineSupport() {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    // Preparado para futura ativação de service worker sem acoplar o restante do app.
  });
}
